
























































import {
  EnvioAutomaticoExecucaoDiaria,
  EnviosAutomaticosExecucoesDiariasService,
  FiltroEnviosAutomaticosExecucoesDiarias
} from "@/services/envios-automaticos-execucoes-diarias.service";
import DataTable from "@/shared/components/data-table.vue";
import DatePicker from "@/shared/components/date-picker.vue";
import Tooltip from "@/shared/components/tooltip.vue";
import { dateFormatterSemHoras, dateHoraMinuto } from "@/shared/filters";
import { ServerPageOptions } from "@/shared/utils/datatable";
import dayjs from "dayjs";
import { Component, Vue } from "vue-property-decorator";

@Component({
  components: { DataTable, Tooltip, DatePicker },
  filters: {
    dateHoraMinuto, dateFormatterSemHoras
  },
})

export default class EnviosDiarios extends Vue {
  filtro: FiltroEnviosAutomaticosExecucoesDiarias = {
    dataInicio: "",
    dataFim: "",
    offset: 0,
    limit: 100,
    order: "",
  }
  idEnviosAutomaticosExecucoesDiariasService: number | null = null;
  selectRow = true;

  promise: Promise<EnvioAutomaticoExecucaoDiaria[]> | null = null;

  headers = [
    { value: "nomeEnvioAutomatico", text: "Envio Automático", withAliasValue: "e.nome" },
    { value: "dataExecucao", text: "Data de Execução", withAliasValue: "ex.dataCriacao" },
    { value: "dataCriacao", text: "Hora do Último Envio", withAliasValue: "ex.dataCriacao" },
    { value: "quantidadeEnviada", text: "Quantidade Enviada", align: 'center', withAliasValue: "quantidadeSucesso"},
    { value: "quantidadePendente", text: "Pendentes", align: 'center' },
    { value: "quantidadeFalha", text: "Quantidade Falha", align: 'center' },
    { value: "total", text: "Total", align: 'center' },
  ];
  dayjs: any;

  mounted() {
    this.filtro.dataInicio = dayjs().format("YYYY-MM-DDT00:00:00");
    this.filtro.dataFim = dayjs().format("YYYY-MM-DDT23:59:59");
    this.fetchEnviosAutomaticosExecucoesDiarias();
  }

  fetchEnviosAutomaticosExecucoesDiarias(options?: ServerPageOptions) {
    if (options) {
      Object.assign(this.filtro, options);
    }
    this.promise = EnviosAutomaticosExecucoesDiariasService.listarEnviosAutomaticosExecucoesDiarias(this.filtro);
  }

  selecionadoEnvio(item: EnvioAutomaticoExecucaoDiaria) {
    if (item) {
      this.$router.push({
        name: "totalqualitativo",
        params: { idEnvioAutomatico: item.idEnvioAutomatico, data: item.dataExecucao },
      });
    }
  }
}
